/**
 * SND-17470 — product page: "stock follows the shopper".
 *
 * 1. On load WITHOUT ?variant= in the URL, if the variant Shopify picked is
 *    worse-stocked than the best one (data attributes rendered by
 *    snippets/soundium-stock-status.liquid via snd-variant-rank), switch the
 *    theme's own variant picker to the best variant. Clicking the radio is
 *    exactly what a shopper does, so price / media / stock morph the usual way.
 *    Links that carry ?variant= (cards, shared links) are left alone.
 * 2. The "<colour> is in our Vilnius store — Choose" row under the stock line
 *    switches the picker the same way; without a matching radio it falls back
 *    to its href (?variant=…).
 */
(() => {
  const SCOPE = '.product-information';

  /** @param {string} id */
  const pick = (id) => {
    const input = document.querySelector(`${SCOPE} input[type="radio"][data-variant-id="${id}"]`);
    if (!(input instanceof HTMLInputElement) || input.checked) return false;
    input.click();
    return true;
  };

  const boot = () => {
    if (new URLSearchParams(location.search).has('variant')) return;
    const chips = document.querySelector(`${SCOPE} .soundium-stock__chips[data-snd-best]`);
    if (!(chips instanceof HTMLElement)) return;
    const { sndBest, sndBestTier, sndCurrent, sndCurrentTier } = chips.dataset;
    if (!sndBest || sndBest === sndCurrent) return;
    if (Number(sndCurrentTier) >= Number(sndBestTier)) return;
    pick(sndBest);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('[data-snd-nudge]') : null;
    if (!(link instanceof HTMLElement)) return;
    if (pick(link.dataset.sndNudge || '')) {
      event.preventDefault();
      link.closest(SCOPE)?.querySelector('.variant-option')?.scrollIntoView({ block: 'nearest' });
    }
  });
})();
